import { render, staticRenderFns } from "./SidebarWrapper.vue?vue&type=template&id=d77c18bc&scoped=true&"
import script from "./SidebarWrapper.vue?vue&type=script&lang=js&"
export * from "./SidebarWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SidebarWrapper.vue?vue&type=style&index=0&id=d77c18bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77c18bc",
  null
  
)

export default component.exports